<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/FlowProduct/Flow' }">产品审批</el-breadcrumb-item>
            <el-breadcrumb-item>待我审批的</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
     <el-row style="text-align:left">
        <el-col :span="24">
          <el-form :model="searchForm" :inline="true" class="demo-form-inline">
            <el-form-item>
              <el-input size="small" clearable v-model="searchForm.searchName" placeholder="请输入搜索关键字，标题，正文等"></el-input>
            </el-form-item>
            <el-form-item>
              <el-select filterable v-model="searchForm.searchFlowId" size="small">
                <el-option
                  v-for="(item,index) in flowOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="small" clearable icon="el-icon-search" @click="Search"></el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="taskList" style="width: 100%" v-loading="loading" size="small">
            <el-table-column prop="Title" label="标题"></el-table-column>
            <el-table-column width="400px" label="摘要">
              <template slot-scope="scope">
                <el-row>
                  <el-col :span="24">审批编号:{{scope.row.InstanceID}}</el-col>
                </el-row>
                <el-row v-for="(item,index) in scope.row.Summary" :key="index">
                  <el-col :span="24">{{item.FieldName}}:{{item.Value}}</el-col>
                </el-row>
              </template>
            </el-table-column>
            <el-table-column prop="StepName" label="当前步骤"></el-table-column>
            <el-table-column :formatter="statusFormatter" prop="Status" label="审核状态"></el-table-column>
            <el-table-column prop="ReceiveName" label="当前处理人"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button @click="handleViewTask(scope.row)" type="text">处理</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
            style="float:right"
          ></el-pagination>
        </el-col>
      </el-row>
    </el-card>
    <el-drawer :size="drawerSize" :title="task.Title" :visible.sync="drawer" :direction="direction">
      <TaskForm :task="task" :drawerShow.sync="drawer" :drawerSize.sync="drawerSize"></TaskForm>
    </el-drawer>
  </div>
</template>
<script>
import {
  GetAllWorkFlow,
  GetWaitTasks
} from "../../until/ZeusApiSDK/Logic/WorkFLowLogic";
import{GetProductWaitTasks,GetProductWorkFlow}from "../../until/ZeusApiSDK/Logic/WorkFlowProductLogic";
import { GetCurrentUserInfo } from "../../until/ZeusApiSDK/Logic/HomeLogic";
import TaskForm from "../../views/FlowProduct/TaskForm";
export default {
  data() {
    return {
      searchName: "",
      searchFlowId: "",
      taskList: [],
      pageSizes: [5,10, 20, 50, 100, 200],
      pageSize: 5,
      pageIndex: 1,
      totalCount: 0,
      loading: true,
      searchForm:{},
      currentUser: {},
      flowOptions: [],
      task: {},
      drawer: false,
      direction: "rtl",
      drawerSize:"30%"
    };
  },
  created() {
    this.InitFlowOption();
    this.getCurrentUser();
    this.GetTaskList();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetTaskList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetTaskList();
    },
    handleViewTask(row) {
      this.drawer = true;
      this.task=row;
      this.task.isFirstStep=false;
    },
    Search: function() {
      this.pageIndex = 1;
      this.GetTaskList();
    },
    //刷新
    Refresh:function(){
      this.GetTaskList();
    },
    getCurrentUser: function() {
      this.currentUser = GetCurrentUserInfo();
    },
    InitFlowOption: function() {
      this.flowOptions.push({ value: "", label: "请选择流程" });
      GetProductWorkFlow().then(res => {
        if (res.length > 0) {
          res.forEach(element => {
            this.flowOptions.push({ value: element.ID, label: element.Name });
          });
        }
      });
    },
    statusFormatter: function(row, column, cellValue, index) {
      var s = "";
      switch (cellValue) {
        case 0:
          s = "等待审批";
          break;
        case 2:
          s = "审批通过";
          break;
        case 3:
          s = "审批拒绝";
          break;
        case 5:
          s = "撤销";
          break;
      }
      return s;
    },
    GetTaskList: function() {
      this.loading = true;
      GetProductWaitTasks(
        this.currentUser.UserId,
        this.searchForm.searchName,
        this.searchForm.searchFlowId,
        this.pageIndex,
        this.pageSize
      ).then(res => {
        if (res) {
          this.taskList = res.DataList;
          this.totalCount = res.TotalCount;
          this.loading = false;
        }
      });
    }
  },
  components: {
    TaskForm
  }
};
</script>
<style>
.el-drawer.rtl{
    overflow: scroll;
}
</style>